/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize, colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const BranchSyncInlineContainer = styled.span({
  display: 'flex',
  alignItems: 'center',
  height: `${gridSize() * 2.5}px`,
});

export const BranchSyncBlockContainer = styled.div({
  height: `${gridSize() * 4}px`,
  background: token('color.background.information', colors.B50),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const InfoIconWrapper = styled.span({
  marginRight: `${gridSize() / 2}px`,
  marginTop: `${gridSize() / 4}px`,
});

export const ActionWrapper = styled.div({
  marginLeft: `-${gridSize()}px`,
});
